<template>
<div id="page-home">
          
    <div class="container">
      <h4 class="title is-5 panel"> {{msg}} </h4>
      
      <div class="columns">
        <div class="column no-gap is-flex is-small">
        
           <div v-for="project in projectTypes" :key="project.id" class="card">
             <div class="card-content">
               <p class="title is-small">{{project.title}}</p>
               <p class="is-small">{{project.description}}</p>
             </div>
             <footer class="card-footer">
                <router-link class="card-footer-item" to="/project">Начать</router-link>
                <router-link class="card-footer-item" :to="{name: 'catalog', params: {id: project.id}}">Содержание</router-link>
                <a href="#" class="card-footer-item">Пример</a>
              </footer>
            </div>

    
    </div>

   </div>
   </div>

</div>
</template>

<script>


// @ is an alias to /src
//import HelloWorld from '@/components/HelloWorld.vue'
//<HelloWorld msg="index page"/>
//       размер каталога: <strong>{{this.$store.state.tableData.length}}</strong> записей <br>
import toolbar from '@/components/toolbar.vue'
import {projectTypes} from '@/repository/projectTypes.js'
import vue from 'vue'
import {mapState} from 'vuex'

export default {
  name: 'home',
  components: {
    toolbar
  },

  data () {
    return {
      projectTypes: [],
      msg: 'Сметные модули на ТО систем безопасности по разным нормативам'
    }
  },

  created: function () {   
    console.log('application created: ' + this.msg);
    this.projectTypes = projectTypes;
    console.log('We have a '+this.projectTypes.length+' project types in repository')
  },

  mounted () {
     // this.$store.dispatch('loadCatalog','/data/jrecords.json');
      //this.$store.loadCatalog('asfdadfsdf');
  },

  computed: {
      ...mapState(['project', 'tableData', 'editorData', 'catalogViewerData'])
  }
}

</script>


<style>
.panel{
    border-radius: 2px;
    border: 1px solid rgba(0, 0, 0, .1);
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.08), inset 0px 0px 0px 1px rgb(255, 255, 255, .3);
}


.card{ border-radius: 3px;}

.card {
    background-color: #fff;
    box-shadow: 0 2px 3px rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.1);
    color: #4a4a4a;
    font-size: .8rem;
    margin: .3rem;
}


.card .card-content{  background-color: transparent;
    height: 100%;
    margin-bottom: -2.7rem;
    padding: 1rem;
    padding-bottom: 4rem;
    
}
.card .title{font-size: 1rem;     margin-bottom: .6rem;}
.card .subtitle{ text-align: left;}

.card-footer {
    background-color: transparent;
    border-top: 1px solid #dbdbdb;
    align-items: stretch;
    display: flex;
        margin-top: auto;
}

.card .card-footer .card-footer-item{padding-top: .02rem; padding-bottom: .02rem; }
.card .card-footer .button{ margin: .2rem; border-radius: 3px; padding: .2rem;  color:white; background:  rgb(102, 105, 134)}
.card .card-footer .button:hover{background-color: rgb(96, 147, 167); color:white}

.card-footer-item:not(:last-child) {
    border-right: 1px solid #dbdbdb;
}
a:link, a:visited, a:active {
    text-decoration: none;
    color: #21b3b4;
}



</style>